import React from 'react';
import { Button } from 'antd';

const ColumnNameSelector = ({
  onClickColumnName,
  selectedColumnGroupIndex,
  selectedColumnName,
  record
}) => {
  const { columnGroupIndex, columnItems } = record;

  if (Array.isArray(columnItems)) {
    const renderedColumnItemButtons = columnItems.map(
      (currentColumnItem, currentColumnItemIndex) => {
        if (currentColumnItemIndex % 2 === 0) {
          return [
            <br />,
            <br />,
            <Button
              onClick={() =>
                onClickColumnName(
                  currentColumnItem.columnName,
                  columnGroupIndex
                )
              }
              type={
                currentColumnItem.columnName === selectedColumnName &&
                columnGroupIndex === selectedColumnGroupIndex
                  ? 'primary'
                  : null
              }
              key={currentColumnItemIndex}>
              {currentColumnItem.label}
            </Button>
          ];
        }

        return (
          <Button
            onClick={() =>
              onClickColumnName(currentColumnItem.columnName, columnGroupIndex)
            }
            type={
              currentColumnItem.columnName === selectedColumnName &&
              columnGroupIndex === selectedColumnGroupIndex
                ? 'primary'
                : null
            }
            key={currentColumnItemIndex}>
            {currentColumnItem.label}
          </Button>
        );
      }
    );

    return renderedColumnItemButtons;
  }

  return null;
};

export default ColumnNameSelector;
